import React from 'react';

export const HeadingAtom = ({
  head_1,
  head_2,
  head_3,
  head_4,
  head_5,
  head_sm,
  className,
  sub_head1,
  sub_head2,
  sub_head_sm,
  clr,
  head4class,
}) => {
  return (
    <div className={`${className} `}>
      <h3
        className={` leading-tight font-gilroy font-light text-${
          clr ? `${clr}` : 'black'
        }`}
      >
        {head_1} <span className="font-gilroy font-bold"> {head_2} </span>
        {head_3}{' '}
        <span
          className={` ${
            head4class ? head4class : ''
          } font-gilroy font-bold`}
        >
          {head_4}
        </span>{' '}
        {head_5}
      </h3>

      <h5
        className={`text-${
          clr ? `${clr}` : 'black'
        } font-poppins md:mt-5 max-w-2xl`}
      >
        {sub_head1}{' '}
      </h5>
      <h5
        className={`text-${
          clr ? `${clr}` : 'black'
        } font-poppins px-10 md:mt-5`}
      >
        {sub_head2}{' '}
      </h5>
    </div>
  );
};
